<div class="modal-header">
  <h5 class="modal-title"><i class="fal fa-user-slash"></i> <ng-container i18n>Close Account</ng-container></h5>
  <button (click)="close()" type="button" class="close">
    <i class="fas fa-times"></i>
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="form">
    <div class="row">
      <div class="col-sm-12">
        <h6 class="header">
          <ng-container i18n>We are sorry that you've chosen to close your account.</ng-container><br />
          <ng-container i18n>Please let us know what's your reason for closing.</ng-container>
        </h6>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-12">
        <mat-radio-group formControlName="reason">
          <mat-radio-button [value]="'cannot-afford'" i18n>
            Your business has suffered significant losses and you cannot afford to keep {{ data.app }}.
          </mat-radio-button>
          <mat-radio-button [value]="'missing-feature'" i18n>
            {{ data.app }} is missing a feature or functionality you desire.
          </mat-radio-button>
          <mat-radio-button [value]="'another-channel-manager'" i18n>
            You are switching to another channel manager.
          </mat-radio-button>
          <mat-radio-button [value]="'no-longer-managing'" i18n>
            You are no longer managing short-term rentals.
          </mat-radio-button>
          <mat-error *ngIf="form.get('reason').touched && form.get('reason').hasError('required')" i18n>
            Please choose a reason
          </mat-error>
        </mat-radio-group>
      </div>

      <div *ngIf="form.get('reason').value === 'another-channel-manager'" class="col-sm-12">
        <mat-form-field class="mat-block">
          <input
            matInput
            placeholder="Do you mind telling us which one?"
            i18n-placeholder
            formControlName="channel_manager"
            type="text"
          />
        </mat-form-field>
      </div>

      <div class="col-sm-12">
        <mat-form-field class="mat-block">
          <input
            matInput
            placeholder="Please let us know what's the best email to reach you at"
            i18n-placeholder
            formControlName="email"
            type="text"
          />
          <mat-error *ngIf="form.get('email').hasError('email')" i18n> Invalid email address </mat-error>
        </mat-form-field>
      </div>

      <div class="col-sm-12 text-center">
        <a class="btn btn-cst-info text-uppercase book-a-call" [href]="data.callScheduleUrl" target="_blank" i18n
          >Book a call</a
        >
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button (click)="close()" type="button" class="btn btn-outline btn-default-outline text-uppercase">
    <i class="fal fa-times"></i> <ng-container i18n>Close</ng-container>
  </button>
  <button (click)="save(form)" type="button" class="btn btn-cst-info create-btn">
    <i class="fas fa-paper-plane"></i> <ng-container i18n>Submit</ng-container>
  </button>
</div>
